/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/jsx-closing-tag-location */
import React from 'react';

/**
 *
 **/

export const updates = [
    {
        key: 1248578692,
        icon: null,
        title: "New Updates",
        description: (
            <span>
                <p>
                    Bukku just got some great new features. Check out the{' '}
                    <a
                        href="https://intercom.help/bukku/en/articles/15989360-release-notes-v2-51-0"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Release Notes
                    </a>{' '}
                    to see what's changed.
                </p>
            </span>
        ),
    },
];
